import { render } from "./EmployeeViewPayment.vue?vue&type=template&id=4b97ff26"
import script from "./EmployeeViewPayment.vue?vue&type=script&lang=js"
export * from "./EmployeeViewPayment.vue?vue&type=script&lang=js"

import "./EmployeeViewPayment.vue?vue&type=style&index=0&id=4b97ff26&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__